import { createGroup, leaveGroup,listMyGroups, generateInviteToken } from "../../services/db";

function cacheKeyForUser(uid) {
  return `kalendario.groups.${uid}`;
}

function readCachedGroups(uid) {
  if (!uid) return [];
  try {
    const raw = localStorage.getItem(cacheKeyForUser(uid));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_err) {
    return [];
  }
}

function writeCachedGroups(uid, groups) {
  if (!uid) return;
  try {
    localStorage.setItem(cacheKeyForUser(uid), JSON.stringify(groups || []));
  } catch (_err) {
    // ignore cache errors
  }
}

export default {
  namespaced: true,
  state: () => ({
    items: [],
    loading: false
  }),
  getters: {
    groups: s => s.items
  },
  mutations: {
    setLoading(s, v) {
      s.loading = v;
    },
    setGroups(s, groups) {
      s.items = groups;
    }
  },
  actions: {
    async refresh({ commit, rootGetters }) {
      const uid = rootGetters["auth/uid"];
      if (!uid) return;

      const cachedGroups = readCachedGroups(uid);
      if (cachedGroups.length) {
        commit("setGroups", cachedGroups);
      }

      commit("setLoading", true);
      try {
        const groups = await listMyGroups(uid);
        commit("setGroups", groups);
        writeCachedGroups(uid, groups);
      } finally {
        commit("setLoading", false);
      }
    },
    async leave({ dispatch }, { groupId, uid }) {
      await leaveGroup({ groupId, uid });
      // opcional: refrescar tras salir
      await dispatch("refresh");
    },
    async create({ dispatch, rootGetters }, { name, type }) {
      const uid = rootGetters["auth/uid"];
      await createGroup({ uid, name, type });
      await dispatch("refresh");
    },
    async inviteLink({ rootGetters }, { groupId }) {
  const uid = rootGetters["auth/uid"];
  const token = await generateInviteToken({ uid, groupId });

  const base = "https://kalendario.thevalkiria.com";
  return `${base}/#/invite/${token}`;
}

  }
};
